import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=1baf8de4&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=1baf8de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf8de4",
  null
  
)

export default component.exports